var React = require('react');

function CapPurple (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(1 1)","fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"stroke":"#FFF","fill":"#3122A3","x":"-.5","y":"-.5","width":"25","height":"25","rx":"12","key":0}),React.createElement("path",{"d":"M4.5 4.5h15v15h-15z","key":1}),React.createElement("path",{"d":"M6.955 12.363v2.5l4.295 2.387 4.295-2.387v-2.5L11.25 14.75l-4.295-2.388zM11.25 6L4.5 9.75l6.75 3.75 5.523-3.069v4.319H18v-5L11.25 6z","fill":"#FFF","fillRule":"nonzero","key":2})]));
}

CapPurple.displayName = "CapPurple";

CapPurple.defaultProps = {"width":"26","height":"26"};

module.exports = CapPurple;

CapPurple.default = CapPurple;
